'use strict';

intellidealerAppCoreModule.factory('alertTypeResource', function ($resource, appConfigurationService) {
  
  var resource = {}; 
  resource.myDealerAlertTypeAreas =  $resource(appConfigurationService.basePath + '/rest/alerttype/myDealerAlertTypeAreas');
  
  return resource;
});
